/* eslint-disable import/prefer-default-export */
import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import moment from "moment-timezone";
import queryClient from "@/utils/queryClient";
import { isLocal } from "./utils/currentRunningEnvironment";

moment.tz.setDefault("America/New_York");

export function rootContainer(container) {
  return (
    <QueryClientProvider client={queryClient}>
      {container}
      {isLocal && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
